export const createAsyncType = (name: string) => ({
  REQUEST: `REQUEST_${name}`.toUpperCase(),
  SUCCESS: `SUCCESS_${name}`.toUpperCase(),
  FAILURE: `FAILURE_${name}`.toUpperCase()
})
